import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  fltLstContainerStyle: { flexGrow: 1, justifyContent: 'space-between', paddingHorizontal: scale(16) },
  topProductsList: { flex: 1 },
});

export default styles;
